'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SVG = require('./SVG');

var _SVG2 = _interopRequireDefault(_SVG);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MdPerson = function MdPerson(props) {
  return _react2.default.createElement(_SVG2.default, {
    style: props.style,
    className: props.className,
    fill: props.color,
    width: props.fontSize,
    height: props.fontSize,
    viewBox: '0 0 1024 1024',
    onClick: props.onClick,
    rotate: props.rotate ? 1 : 0,
    shake: props.shake ? 1 : 0,
    beat: props.beat ? 1 : 0
  }, _react2.default.createElement('path', {
    d: 'M512 512c105.61 0 192-86.402 192-192s-86.39-192-192-192-192 86.402-192 192 86.39 192 192 192zM512 608c-127.196 0-384 64.804-384 192v96h768v-96c0-127.196-256.804-192-384-192z'
  }));
};

MdPerson.defaultProps = {
  // style
  style: {},
  color: '#000000',
  fontSize: '22px',
  // animation
  shake: false,
  beat: false,
  rotate: false
};
MdPerson.propTypes = {
  // style
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  fontSize: _propTypes2.default.string,
  // animation
  shake: _propTypes2.default.bool,
  beat: _propTypes2.default.bool,
  rotate: _propTypes2.default.bool,
  // functions
  onClick: _propTypes2.default.func
};
exports.default = MdPerson;
module.exports = exports['default'];